import { classNames, Component, h, tag } from "omi";

import { IconName, NWIcon } from "@/wc/components";
import { tailwind } from "@/tailwind";

type Props = {
  icon?: IconName;
  iconOnly?: boolean;
  iconSize?: { width: number; height: number };
  withIndicator?: boolean;
  color?: "brand" | "gray" | "gray-filled" | "success";
  padding?: "xs" | "sm" | "md";
};

@tag("nw-badge")
export class NWBadge extends Component<Props> {
  static css = [tailwind];

  static propTypes = {
    withIndicator: Boolean,
    color: String,
    padding: String,
    icon: String,
    iconOnly: Boolean,
    iconSize: Object,
  };

  render({ icon, iconSize, padding = "md", iconOnly = false, withIndicator = false, color = "gray" }: Props) {
    return (
      <div
        id="badge"
        class={classNames(
          "flex select-none whitespace-nowrap text-nowrap items-center rounded-lg border shadow-xs text-center font-medium leading-5 uppercase",
          {
            "border-gray-300": color === "gray",
            "border-gray-300 bg-primary": color === "gray-filled",
            "border-brand-300 bg-primary text-leather": color === "brand",
            "border-success-300 bg-success-50 text-success-600": color === "success",
          },
          {
            "py-0.5 px-1.5 space-x-1 text-xs": padding === "xs",
            "py-0.5 px-1.5 space-x-1 text-sm": padding === "sm",
            "py-1 px-3 space-x-2 text-sm": padding === "md",
          },
        )}
      >
        {icon && <NWIcon name={icon} width={iconSize?.width || 12} height={iconSize?.height || 12} />}
        {withIndicator && <div class="bg-leather w-1.5 h-1.5 rounded-full"></div>}
        {!iconOnly && (
          <p>
            <slot></slot>
          </p>
        )}
      </div>
    );
  }
}
